import * as React from 'react';
import { Layout, Notification, Cell } from '@wix/design-system';
import { useTranslation } from '../../../hooks/use-translation';
export function MarketingIntegrationsToast({ navigateToMarketingIntegration, }) {
    const t = useTranslation();
    return (React.createElement(Layout, null,
        React.createElement(Cell, null,
            React.createElement(Notification, { show: true },
                React.createElement(Notification.TextLabel, null, t('manage-apps.marketing-integrations-toast.done')),
                React.createElement(Notification.ActionButton, { onClick: () => navigateToMarketingIntegration() }, t('manage-apps.marketing-integrations-toast.back')),
                React.createElement(Notification.CloseButton, null)))));
}
//# sourceMappingURL=marketing-integrations-toast.js.map